import Image from "next/image";
import { useLocale } from "next-intl";
import React, { type ReactElement } from "react";
import {
  FeatureCard,
  FeatureCardContent,
  FeatureCardTitle,
  FeatureCardDescription,
  FeatureCardLink,
  FeatureCardImage,
} from "@/components";
import { Project } from "@/types";

interface GalleryListProps {
  projects: Project[];
}

function GalleryList({ projects }: Readonly<GalleryListProps>): ReactElement {
  const locale = useLocale();

  return (
    <section className="max-w-7xl mx-auto grid grid-col-1 md:grid-cols-2 gap-3 p-4">
      {projects.map((project) => {
        return (
          <FeatureCard
            key={project.id}
            className="relative flex flex-col border rounded-lg h-[400px]"
          >
            <FeatureCardContent className="relative flex-1 z-10 text-white justify-end items-start p-4">
              <FeatureCardTitle>{project.name[locale]}</FeatureCardTitle>
              {project.description ? (
                <FeatureCardDescription className="max-w-2/3 opacity-75">
                  {project.description[locale]}
                </FeatureCardDescription>
              ) : null}
              <FeatureCardLink href={project.url} />
            </FeatureCardContent>
            {project.picture ? (
              <FeatureCardImage className="absolute inset-0">
                <Image
                  alt=""
                  className="max-w-none h-full lg:max-w-full lg:h-auto"
                  height={960}
                  src={project.picture}
                  width={1440}
                  unoptimized
                />
                <span className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/80" />
              </FeatureCardImage>
            ) : null}
          </FeatureCard>
        );
      })}
    </section>
  );
}

export { GalleryList, type GalleryListProps };
